module.exports = __webpack_public_path__ + "img/ok.2301a622.svg";